import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';
import { debounce } from 'throttle-debounce';

import { suggestionsRequestAction, suggestionsReset } from '../../../actions/suggestions';
import { DEFAULT_INPUT_DELAY } from '../../../constants/delays';
import { TThunkDispatch } from '../../../types/redux/thunk';
import { MIN_CHARS_TO_DISPLAY_SUGGEST } from '../constants';

export const useDebouncedValueEffect = (value: string, openSuggest: Function, closeSuggest: Function) => {
  const dispatch: TThunkDispatch = useDispatch();
  const deviceType = useDeviceType();

  const [isDebouncing, setIsDebouncing] = React.useState(false);

  // oxlint-disable-next-line react/exhaustive-deps
  const requestSuggestionsDebounced = React.useCallback(
    debounce(DEFAULT_INPUT_DELAY, (value: string) => {
      dispatch(suggestionsRequestAction(value));
      setIsDebouncing(false);
    }),
    [dispatch],
  );

  React.useEffect(() => {
    if (value.length >= MIN_CHARS_TO_DISPLAY_SUGGEST) {
      setIsDebouncing(true);
      requestSuggestionsDebounced(value);
    } else {
      dispatch(suggestionsReset());
    }
  }, [value, requestSuggestionsDebounced, dispatch]);

  React.useEffect(() => {
    if (deviceType === 'desktop') {
      if (value.length >= MIN_CHARS_TO_DISPLAY_SUGGEST) {
        openSuggest();
      } else {
        closeSuggest();
      }
    } else if (value.length > 0) {
      // Если установили в фокус и начали писать, нужно открыть модалку саджеста.
      openSuggest();
    }
  }, [deviceType, value, openSuggest, closeSuggest]);

  return isDebouncing;
};
